// Regolamenti fissi dei 4 giochi RinoMagic.
// Testi basati sulla logica di gioco implementata nel backend.
// (Modificabili manualmente: al prossimo redeploy vengono aggiornati.)

export const REGOLAMENTI = {
  thebesttiket: {
    title: "Regolamento — TheBestTicket",
    color: "#F59E0B",
    intro:
      "Schedine tra amici. Ogni stanza è indipendente: ognuno gioca i propri pronostici con la puntata che preferisce. Chi totalizza la quota complessiva più alta vince.",
    sections: [
      {
        heading: "📌 Accesso",
        items: [
          "Si entra nel gruppo esclusivamente tramite codice invito.",
        ],
      },
      {
        heading: "💰 Puntate",
        items: [
          "Libere. Ognuno punta la cifra che desidera per la giornata.",
        ],
      },
      {
        heading: "🔄 Pagamenti (Sistema a Cascata Proporzionale)",
        items: [
          "Il nuovo e rivoluzionario sistema di pagamento distribuisce le vincite in modo proporzionale a cascata tra i partecipanti.",
        ],
      },
      {
        heading: "⚽ Come si gioca",
        items: [
          "Inserisci un pronostico per ciascuna partita presente nel palinsesto di giornata.",
          "Giocate valide solo entro la scadenza fissata (Deadline).",
        ],
      },
      {
        heading: "🏆 Chi vince",
        items: [
          "Non vince chi prende tutta la schedina, ma chi totalizza la quota complessiva più alta con i pronostici indovinati.",
        ],
      },
      {
        heading: "🎁 Gioco bonus (Big Match)",
        items: [
          "Indovina il risultato esatto del Big Match della settimana: in palio un premio speciale ogni settimana.",
        ],
      },
    ],
    footer: "",
  },

  scoretolive: {
    title: "Regolamento — ScoreToLive",
    color: "#3B82F6",
    intro:
      "Torneo a eliminazione sui marcatori. Indovina chi segna, giornata dopo giornata, e resta in vita più a lungo degli altri.",
    sections: [
      {
        heading: "Come si gioca",
        items: [
          "Ogni giocatore parte con un numero di vite deciso dall'admin alla creazione del torneo.",
          "Si entra solo con il codice invito univoco del torneo.",
          "Ad ogni giornata scegli un marcatore per ciascuna partita giocabile.",
        ],
      },
      {
        heading: "Vite ed eliminazione",
        items: [
          "Una scelta sbagliata (il tuo marcatore non segna) costa una vita.",
          "Quando arrivi a zero vite sei eliminato dal torneo.",
          "Le partite rinviate non costano mai vite.",
        ],
      },
      {
        heading: "Marcatori bloccati",
        items: [
          "Quando indovini un marcatore, SOLO quel giocatore diventa non più selezionabile per il resto del torneo.",
          "Il resto della squadra resta disponibile per le giornate successive.",
        ],
      },
    ],
    footer: "Sopravvivi indovinando i marcatori giusti.",
  },

  fantagiornata: {
    title: "Regolamento — FantaGiornata",
    color: "#A855F7",
    intro:
      "Fantacalcio a giornata singola: schieri la tua formazione ogni giornata e sfidi la lega. Vince chi somma più fantavoto.",
    sections: [
      {
        heading: "Come si gioca",
        items: [
          "Si entra in una lega solo con il codice invito univoco.",
          "Ogni giornata schieri 11 titolari + 8 in panchina, rispettando i ruoli (2 Portieri, 2 Difensori, 2 Centrocampisti, 2 Attaccanti in panchina).",
          "La formazione va inviata prima della scadenza della giornata.",
        ],
      },
      {
        heading: "Calcolo dei punti",
        items: [
          "Dopo il caricamento dei Voti ufficiali, ad ogni giocatore viene assegnato il proprio fantavoto.",
          "Un titolare senza voto viene sostituito automaticamente con un giocatore della panchina dello stesso ruolo.",
          "Il punteggio di giornata è la somma dei fantavoto della tua formazione.",
        ],
      },
      {
        heading: "Classifica",
        items: [
          "Vince chi fa più punti nella singola giornata; se si gioca su più giornate, vince chi totalizza più punti nella classifica cumulativa.",
        ],
      },
    ],
    footer: "Schiera la formazione giusta e domina la lega.",
  },

  survival: {
    title: "Regolamento — Survival 2.0",
    color: "#EF4444",
    intro:
      "Torneo a eliminazione sui pronostici 1X2. Ogni vita è un pronostico: sopravvivi più a lungo di tutti per vincere.",
    sections: [
      {
        heading: "Come si gioca",
        items: [
          "Parti con 3 vite (o quante decise dall'admin). Si entra solo con codice invito univoco.",
          "Ogni giornata invii un numero di pronostici pari alle vite che possiedi all'inizio della giornata (3 vite = 3 pronostici su 3 partite diverse).",
          "Ogni pronostico è un segno 1 (casa), X (pareggio) o 2 (trasferta).",
        ],
      },
      {
        heading: "Squadre bloccate",
        items: [
          "Pronostico esatto con \"1\" → blocca la squadra di casa; con \"2\" → blocca la squadra ospite.",
          "Pronostico esatto con \"X\" → non blocca nessuna squadra (eccezione).",
          "Una squadra già bloccata non può essere riutilizzata con lo stesso segno nelle giornate successive.",
        ],
      },
      {
        heading: "Vite ed eliminazione",
        items: [
          "Ogni pronostico sbagliato costa una vita.",
          "A zero vite sei eliminato dal torneo.",
        ],
      },
      {
        heading: "Concessione e Tie-break",
        items: [
          "Concessione: se in una partita entrambe le squadre sono già bloccate, quella partita torna giocabile con qualsiasi segno (1, X o 2) e il suo esito non blocca nuove squadre.",
          "Tie-break / Resurrezione: se in una giornata tutti i giocatori ancora in vita verrebbero eliminati insieme, vengono riportati allo stato della giornata precedente e il torneo prosegue. L'evento è evidenziato in classifica.",
        ],
      },
      {
        heading: "Partite eliminate o sospese",
        items: [
          "Partita ELIMINATA (non si gioca): non viene considerata nel calcolo.",
          "Partita SOSPESA (giocata ma interrotta): il segno 1X2 è sempre NULLO (quota 1.00).",
          "Sulla sospesa restano validi i mercati Gol/NoGol e Over/Under se il punteggio parziale ne garantisce già l'esito.",
        ],
      },
    ],
    footer: "3 vite, 1 pronostico a vita: l'ultimo sopravvissuto vince.",
  },

  bonus: {
    title: "Regolamento — Giochi Bonus",
    color: "#10B981",
    intro:
      "Un bonus a giornata per ogni gioco: indovina il pronostico bonus e vinci un premio extra da usare nel gioco corrispondente.",
    sections: [
      {
        heading: "Come funziona",
        items: [
          "Sei idoneo al bonus solo se sei iscritto a una stanza o torneo del gioco corrispondente.",
          "Ogni giornata c'è un pronostico bonus: risultato esatto del Big Match oppure primo marcatore.",
          "Dopo la scadenza puoi vedere i pronostici bonus di tutti i partecipanti.",
        ],
      },
      {
        heading: "Premi",
        items: [
          "TheBestTicket → regala una giocata.",
          "ScoreToLive → +3.",
          "Survival → +1 vita.",
          "FantaGiornata → +3 (diventi il 12° uomo in campo).",
        ],
      },
    ],
    footer: "Indovina il bonus e parti avvantaggiato nel tuo gioco.",
  },
};
